type SetCookieParams = {
    name: string;
    value: string;
    domain?: string;
    path?: string;
    maxAgeSec?: number;
    secure?: boolean;
    sameSite?: 'Strict' | 'Lax' | 'None';
};

type DeleteCookieParams = {
    name: string;
    domain?: string;
    path?: string;
};

const setCookie = ({name, value, domain, path = '/', maxAgeSec, secure, sameSite}: SetCookieParams): void => {
    let cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;

    if (domain) cookie += `; domain=${domain}`;
    if (path) cookie += `; path=${path}`;
    if (maxAgeSec !== undefined) cookie += `; max-age=${maxAgeSec}`;
    if (secure) cookie += '; secure';
    if (sameSite) cookie += `; samesite=${sameSite}`;

    document.cookie = cookie;
};

const deleteCookie = ({name, domain, path = '/'}: DeleteCookieParams): void => {
    setCookie({name, value: '', domain, path, maxAgeSec: 0});
};

const getCookie = (name: string): string | null => {
    const encoded = encodeURIComponent(name);
    const cookies = document.cookie.split('; ');

    for (const cookie of cookies) {
        const [cookieName, ...rest] = cookie.split('=');

        if (cookieName === encoded) {
            return decodeURIComponent(rest.join('='));
        }
    }

    return null;
};

const hasCookie = (name: string): boolean => getCookie(name) !== null;

export {deleteCookie, getCookie, hasCookie, setCookie};
